module.exports = __webpack_public_path__ + "static/media/icon.e716165f.png";